import React from 'react';

export const WarningIcon = ({
    className,
    color = '#f80',
}: {
    className?: string;
    color?: string;
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.5"
        height="16.5"
        viewBox="0 0 16.5 16.5"
        className={className}
    >
        <g
            id="Icon_feather-alert-circle"
            data-name="Icon feather-alert-circle"
            transform="translate(-2 -2)"
        >
            <path
                id="Path_1389"
                data-name="Path 1389"
                d="M17.5,10.25A7.25,7.25,0,1,1,10.25,3,7.25,7.25,0,0,1,17.5,10.25Z"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
            <path
                id="Path_1390"
                data-name="Path 1390"
                d="M18,12v2.9"
                transform="translate(-7.75 -4.65)"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
            <path
                id="Path_1391"
                data-name="Path 1391"
                d="M18,24h0"
                transform="translate(-7.75 -10.85)"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
        </g>
    </svg>
);
